/**
 * API Configuration Constants
 */

/**
 * Default number of cryptocurrencies to fetch
 */
export const DEFAULT_CRYPTO_COUNT = 100;

/**
 * Number of news articles for simplified view (homepage)
 */
export const SIMPLIFIED_NEWS_COUNT = 6;

/**
 * Number of news articles for full news page
 */
export const FULL_NEWS_COUNT = 12;

/**
 * Number of top cryptocurrencies to display on homepage
 */
export const HOMEPAGE_TOP_CRYPTOS = 10;

/**
 * Default news category
 */
export const DEFAULT_NEWS_CATEGORY = 'Cryptocurrency';

/**
 * News API default categories
 */
export const NEWS_DEFAULT_CATEGORIES = 'BTC,ETH,BLOCKCHAIN';
